let components = [];

export function ProjectsAwards(rootDom) {
    const selector = {
        ACTIVE: '_active',
        HIDDEN: '_hidden',
        DATA_FILTER: '[data-filter]',
    };
    const $buttons = $('.js-projects-awards-filter', rootDom).find(selector.DATA_FILTER);
    const $contents = $('.js-projects-awards-filter-content', rootDom).find(selector.DATA_FILTER);
    const $awardMore = $('.js-projects-award-more', rootDom);
    const $awardLess = $('.js-projects-award-less', rootDom);

    if (!$buttons.length) return;

    // HANDLERS
    $buttons.on('click', onToggle);
    $awardMore.on('click', showAwardMore);
    $awardLess.on('click', showAwardLess);

    // PRIVATE
    function onToggle(e) {
        const tag = e.currentTarget.dataset.filter;

        $buttons.removeClass(selector.ACTIVE);
        $(e.currentTarget).addClass(selector.ACTIVE);

        if (!tag) {
            $contents.removeClass(selector.HIDDEN);
            return;
        }

        $contents
            .addClass(selector.HIDDEN)
            .filter((i, elDom) => elDom.dataset.filter.includes(tag))
            .removeClass(selector.HIDDEN);
    }

    function showAwardMore(e) {
        $(e.currentTarget).attr('hidden', true);
        $awardLess.attr('hidden', false);
    }

    function showAwardLess(e) {
        $(e.currentTarget).attr('hidden', true);
        $awardMore.attr('hidden', false);
    }

    // PUBLIC
    function destroy() {
        $buttons.off('click', onToggle);
        $awardMore.off('click', showAwardMore);
    }

    return {
        destroy
    };
}

// Инициализируем награды с фильтром в новой странице
function init(e, data) {
    const pageContainerDom = data.next.container;

    components = Array.from(pageContainerDom.querySelectorAll('.js-projects-awards')).map(ProjectsAwards);
}

App.W.on("barba:afterEnter", init);
App.W.on('barba:leave', () => {
    if (components.length) {
        components.forEach(component => component.destroy());
        components = [];
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/ProjectsAwards.js